// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SoKe","question":"styles_question__2LXmf","description":"styles_description__1zYML"};